import { render, staticRenderFns } from "./Solicita.vue?vue&type=template&id=61220468&scoped=true"
import script from "./Solicita.vue?vue&type=script&lang=js"
export * from "./Solicita.vue?vue&type=script&lang=js"
import style0 from "./Solicita.vue?vue&type=style&index=0&id=61220468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61220468",
  null
  
)

export default component.exports